import { render, staticRenderFns } from "./GroupSelect.vue?vue&type=template&id=52ff1b67"
import script from "./GroupSelect.vue?vue&type=script&lang=ts"
export * from "./GroupSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports